import { FormApplication } from '../../shared/models/form-application.model';
import { ReferenceDataOptionLists } from './../../../lib/constants/reference-data-option-lists';
import { Address } from './../../../lib/models/api/address.model';
import { ApplicantDependant } from './applicant-dependant.model';
import { Applicant } from './applicant.model';
import { ApplicationDepositSourceType } from './application-deposit-source-type.model';
import { ApplicationProductRepaymentMethod } from './application-product-repayment-method.model';
import { ApplicationProduct } from './application-product.model';
import { BrandConsent } from './brand-consent.model';
import { CaseProduct } from './case-product.model';
import { Consent } from './consent.model';
import { FactFind2 } from './fact-find2.model';
import { PropertyOccupant } from './property-occupant.model';
import { RemortgageUse } from './remortgage-use.model';

export class MortgageApplication extends FormApplication {
  public PropositionLogoPath: string;
  public SourceKfiNumberAsHash: string;
  public ShouldSetBlankFinalDecision: boolean;
  public CheckConsentValidation: boolean;
  public DprFeeCallRequired: boolean;
  public IsKfiAccepted: boolean;
  public IsFactFindApplicantOrderChangeAfterSam: boolean;
  public WasKycCheckPerformed: boolean;
  public HasKycFailedResultForAnyApplicant: boolean;
  public IsInRoiBrokerCase: boolean;
  public ApplicationNumber: number;
  public CaseNumber?: number;
  public LoanTypeCode: string;
  public AboveCommercialPremisesCode: string;
  public AccountHolderName: string;
  public AccountNumber: string;
  public AddHlcFee?: boolean;
  public AdditionalInformation: string;
  public PropertyTypeCode: string;
  public BankBuildingSocietyName: string;
  public TrueMarketPrice?: number;
  public CurrentMortgageBalance?: number;
  public DateAipSubmitted?: Date;
  public DateStatusLastModified?: Date;
  public ExGovernmentCode: string;
  public FeeID?: number;
  public IsFinalUnderwriterDecision?: boolean;
  public PackagerAddressID?: number;
  public PropertyAccessContactAddressID?: number;
  public PropertyAddressID?: number;
  public PropertySellingEstateAgentAddressID?: number;
  public SolicitorAddressID?: number;
  public SolicitorConveyaneFirmAddressID?: number;
  public SourceAipID?: number;
  public SourceKfiNumber?: number;
  public VendorAddressID?: number;
  public ForBusinessPurposesCode: string;
  public FromMte?: boolean;
  public Guid: string;
  public InternalUserName: string;
  public IsPropertyPartToBeLetCode: string;
  public IndividualActing: string;
  public Ltv?: number;
  public NumberOfBathrooms?: number;
  public NumberOfBedrooms?: number;
  public NumberOfKitchens?: number;
  public NumberOfStoreys?: number;
  public OwnershipTypeCode: string;
  public PurchasePropertyPrice?: number;
  public ReceiveDiscountOnPurchaseCode: string;
  public RemainingLease?: number;
  public RemainingTerm?: number;
  public RemortgageEstimatedPropertyValue?: number;
  public SamAccountNumber: string;
  public SamDownloadDate?: Date;
  public SamLatestStatusCode: string;
  public SamTimeToBeDownloaded?: Date;
  public SortCode1: string;
  public SortCode2: string;
  public SortCode3: string;
  public StatusCode: string;
  public SubmissionNumber?: number;
  public TransactAction: string;
  public TransactAddressMatched: string;
  public TransactBureauResponse: string;
  public TransactBureauResponseError: string;
  public TransactCreditSearchResult: string;
  public TransactDecision: string;
  public TransactDateOfResponse?: Date;
  public TransactErrorCode: string;
  public TransactErrorMessage: string;
  public TransactGoBureau: string;
  public TransactHighestPolicyRule: string;
  public TransactLatestScoreband: string;
  public TransactMultiplier?: number;
  public TransactNumber?: number;
  public TransactResponseTime?: number;
  public PropertyLetToRelativeCode: string;
  public EstimatedUnfurnishedMonthlyRental?: number;
  public PropertyTenantsOnCompletionCode: string;
  public DateFirstTenantOccupiedTheProperty?: Date;
  public DateTenacyAgreementFinishes?: Date;
  public MonthlyRentCurrentlyPaidByTenants?: number;
  public PropertyYearOfConstructionCode: string;
  public PurchaseDateOfPropertyRemortgaging?: Date;
  public BranchFad: string;
  public SubjectToLeaseCode: string;
  public PropertyOriginalPrice?: number;
  public PurchasingAtConcessionaryPriceCode: string;
  public ConcessionNature: string;
  public FloorNo?: number;
  public ForBusinessPurposesDetails: string;
  public ReceiveDiscountOnPurchaseDetails: string;
  public PrivateSaleCode: string;
  public RelationshipToVendor: string;
  public SolicitorChosenCode: string;
  public QuoteFromLegalPartnersCode: string;
  public NoPeopleAgedOver17?: number;
  public ProductSelectionTypeCode: string;
  public ApplyHelpToBuySchemeCode: string;
  public InterestAnyOtherPropertyCode: string;
  public InstructSurveyContactCode: string;
  public DecisionText: string;
  public KnowPropertyDetailsCode: string;
  public ContinuingMonthlyPayments?: number;
  public LastModifiedDate?: Date;
  public LastModifiedAgentID?: number;
  public LastModifiedStaffID?: number;
  public SubmittedStaffID?: number;
  public SubmittedAgentID?: number;
  public FinalUnderwriterDecisionDate?: Date;
  public UnderwriterDecisionID?: number;
  public FinalUnderwriterDecisionCode: string;
  public HowManyBtlWithUs?: number;
  public BtlWithUsTotalOutstandingLoanAmount?: number;
  public OtherBtlWithUsDetails: string;
  public HowManyBtlInTotal?: number;
  public IsAuditable?: boolean;
  public EstimatedFurnishedMonthlyRental?: number;
  public DecisionTextSummary: string;
  public ConsentID?: number;
  public RemortgageUseID?: number;
  public CurrentDecisionCode: string;
  public WasAssessmentReleased?: boolean;
  public MortgagePayOffAmount?: number;
  public MortgageRemainderFundingDetails: string;
  public DecisionTypeCode: string;
  public DateCreated?: Date;
  public SubmittedBranchUserID?: number;
  public LastModifiedBranchUserID?: number;
  public SubmittedDirectCustomerID?: number;
  public LastModifiedDirectCustomerID?: number;
  public IsRentalPaidInSterlingCode: string;
  public ReleasedFromAdvised?: boolean;
  public HasOutgoingsCode: string;
  public DateOfEntry?: Date;
  public SolicitorSequenceNumber?: number;
  public PropertySharePercentage?: number;
  public MonthlyRentalForNotPurchasedProperty?: number;
  public SolicitorFromPanelCode: string;
  public ApplicationTypeCode: string;
  public DateCIDDIssued?: Date;
  public DateNICHALetterReceived?: Date;
  public IsNICHAApplication: string;
  public AffordabilityResultID?: number;
  public SourceFFNumber?: number;
  public SuitabilityReportID?: number;
  public SoftCreditResultCode: string;
  public IsDataCompleted?: boolean;
  public MonthlySponsorOutgoings?: number;
  public IsSingleFamilyPropertyCode: string;
  public IsHMOLicenceRequiredCode: string;
  public NoPeopleOnTenancyAgreement?: number;
  public ApplicationVersion?: number;
  public BrandConsentID?: number;
  public MortgageApplicationExtendedID?: number;
  public TotalBalanceOutstandingBtlMortgage?: number;
  public TotalMonthlyRentalIncomeBtl?: number;
  public PackagerAddress: Address;
  public PropertyAccessContactAddress: Address;
  public PropertyAddress: Address;
  public PropertySellingEstateAgentAddress: Address;
  public SolicitorAddress: Address;
  public SolicitorConveyaneFirmAddress: Address;
  public VendorAddress: Address;
  public Applicants: Array<Applicant>;
  public ApplicationDepositSourceTypes: Array<ApplicationDepositSourceType>;
  public ApplicationProducts: Array<ApplicationProduct>;
  public BrandConsent: BrandConsent;
  public Consent: Consent;
  public FactFind2: FactFind2;
  public RemortgageUse: RemortgageUse;
  public PropertyOccupants: Array<PropertyOccupant>;
  public MoreThanOneSignatoryForDirectDebitCode: string;
  public OfferDistributionChannel: string;

  public EPCRating: string;
  public EPCDateIssued?: Date;
  public EPCCertificateNo: number;

  public isNorthernIrelandProperty: boolean;
  public isScottishPropertyAndFullApplication: boolean;
  public isInterestAnyOtherPropertyCodeVisible: boolean;
  public isUnregisteredFactFind: boolean;

  deserialize(input: any): this {
    super.deserialize(input);
    this.deserializeApplicationProducts(input);
    this.setApplicationCaseDependentProperties();

    this.PackagerAddress = new Address().deserialize(input.PackagerAddress);
    this.PropertyAccessContactAddress = new Address().deserialize(input.PropertyAccessContactAddress);
    this.PropertyAddress = new Address().deserialize(input.PropertyAddress);
    this.PropertySellingEstateAgentAddress = new Address().deserialize(input.PropertySellingEstateAgentAddress);
    this.SolicitorAddress = new Address().deserialize(input.SolicitorAddress);
    this.SolicitorConveyaneFirmAddress = new Address().deserialize(input.SolicitorConveyaneFirmAddress);
    this.VendorAddress = new Address().deserialize(input.VendorAddress);
    this.Applicants = input.Applicants.map((applicant) => new Applicant().deserialize(applicant));
    if (input.ApplicationDepositSourceTypes) {
      this.ApplicationDepositSourceTypes = input.ApplicationDepositSourceTypes.map((applicationDepositSourceType) =>
        new ApplicationDepositSourceType().deserialize(applicationDepositSourceType)
      );
    }
    this.BrandConsent = new BrandConsent().deserialize(input.BrandConsent);
    this.Consent = new Consent().deserialize(input.Consent);
    this.FactFind2 = input.FactFind2 ? new FactFind2().deserialize(input.FactFind2) : undefined;
    this.RemortgageUse = new RemortgageUse().deserialize(input.RemortgageUse);
    if (input.PropertyOccupants) {
      this.PropertyOccupants = input.PropertyOccupants.map((propertyOccupant) =>
        new PropertyOccupant().deserialize(propertyOccupant)
      );
    }

    return this;
  }

  private deserializeApplicationProducts(input: any): void {
    if (input.ApplicationProducts && input.ApplicationProducts.length > 0) {
      this.ApplicationProducts = input.ApplicationProducts.map((applicationProduct) =>
        new ApplicationProduct().deserialize(applicationProduct)
      );
      input.ApplicationProducts.length > 1 ? this.configurePartAndPart() : this.configureSingleProduct();
    } else {
      this.configureNoProduct();
    }
  }

  private configurePartAndPart(): void {
    this.RepaymentTypeCodeCache = ReferenceDataOptionLists.RepaymentTypePartAndPart;

    if (
      this.ApplicationProducts[1].CaseProduct.LoanAmount !== null &&
      this.ApplicationProducts[1].CaseProduct.LoanAmount !== undefined
    ) {
      this.LoanAmountCache =
        this.ApplicationProducts[0].CaseProduct.LoanAmount + this.ApplicationProducts[1].CaseProduct.LoanAmount;
    }

    const product = this.ApplicationProducts[0].CaseProduct.Product;
    if (product) {
      delete (product as any).$id;
      this.ApplicationProducts[1].CaseProduct.Product = product;
    }
  }

  private configureSingleProduct(): void {
    this.LoanAmountCache = this.ApplicationProducts[0].CaseProduct.LoanAmount;
    this.RepaymentTypeCodeCache = this.ApplicationProducts[0].CaseProduct.RepaymentTypeCode;
  }

  private configureNoProduct(): void {
    this.ApplicationProducts = new Array<ApplicationProduct>();
    const applicationProduct = new ApplicationProduct();
    applicationProduct.CaseProduct = new CaseProduct();
    applicationProduct.ApplicationProductRepaymentMethods = new Array<ApplicationProductRepaymentMethod>();
    this.ApplicationProducts.push(applicationProduct);
  }

  public isRemortgageOrKnowsPropertyDetails(): boolean {
    return this.KnowPropertyDetailsCode === ReferenceDataOptionLists.AnswerTypeYes || this.isRemortgage;
  }

  public isMortgageApplicationFlatProperty(): boolean {
    const flatPropertyTypes = [
      ReferenceDataOptionLists.PropertyTypeConvertedStudioFlat,
      ReferenceDataOptionLists.PropertyTypeConvertedFlat,
      ReferenceDataOptionLists.PropertyTypePurposeBuiltFlat,
      ReferenceDataOptionLists.PropertyTypePurposeBuiltStudioFlat
    ];

    return flatPropertyTypes.indexOf(this.PropertyTypeCode) >= 0;
  }

  public arePropertyDetailsVisible(): boolean {
    return this.IsFullApp ? true : this.IsAip && this.isRemortgageOrKnowsPropertyDetails();
  }

  public arePropertyDetailsVisibleIncludingFactFind(): boolean {
    const isFactFindAndRemortgageOrKnowsPropertyDetails = this.IsFactFind && this.isRemortgageOrKnowsPropertyDetails();

    return isFactFindAndRemortgageOrKnowsPropertyDetails ? true : this.arePropertyDetailsVisible();
  }

  public areFlatDetailsVisible(): boolean {
    const isFlatPropertyType = this.isMortgageApplicationFlatProperty();
    const isVisible = this.IsFullApp
      ? isFlatPropertyType
      : isFlatPropertyType && this.isRemortgageOrKnowsPropertyDetails();

    return isVisible;
  }

  public nullifyFlatDetailsRelatedFields(): void {
    if (!this.areFlatDetailsVisible()) {
      this.NumberOfStoreys = undefined;
      this.FloorNo = undefined;
      this.AboveCommercialPremisesCode = undefined;
    }
  }

  public isSubjectToLeaseVisible(): boolean {
    const isFlatPropertyType = this.isMortgageApplicationFlatProperty();
    let isVisible = this.OwnershipTypeCode === ReferenceDataOptionLists.TenureTypeFreehold && isFlatPropertyType;

    if (this.IsAip) {
      isVisible = this.isRemortgageOrKnowsPropertyDetails() && isVisible;
    }
    if (this.IsFactFind) {
      isVisible = false;
    }
    if (!isVisible) {
      this.SubjectToLeaseCode = undefined;
    }

    return isVisible;
  }

  public nullifySubjectToLeaseCode(): void {
    if (!this.isSubjectToLeaseVisible()) {
      this.SubjectToLeaseCode = undefined;
    }
  }

  public isRemainingLeasePeriodVisible(): boolean {
    const ownershipLeaseholdOrSubjectToLease =
      this.OwnershipTypeCode === ReferenceDataOptionLists.TenureTypeLeasehold ||
      this.SubjectToLeaseCode === ReferenceDataOptionLists.AnswerTypeYes;
    const knowPropertyDetailsOrRemortgage =
      this.KnowPropertyDetailsCode === ReferenceDataOptionLists.AnswerTypeYes || this.isRemortgage;

    return this.IsFullApp
      ? ownershipLeaseholdOrSubjectToLease
      : knowPropertyDetailsOrRemortgage && ownershipLeaseholdOrSubjectToLease;
  }

  public hasLegalServiceFree(): boolean {
    const caseProduct = this.getCaseProduct();

    if (caseProduct !== undefined) {
      return (
        caseProduct.Product &&
        (this.isRemortgageWithFreeLegalService(caseProduct) || this.isPurchaseWithFreeLegalService(caseProduct))
      );
    }
  }

  public isRemortgageWithFreeLegalService(caseProduct): boolean {
    return this.isRemortgage && caseProduct.Product.HasFreeLegalServiceForRemortgage;
  }

  public isPurchaseWithFreeLegalService(caseProduct): boolean {
    return this.isPurchase && caseProduct.Product.HasFreeLegalServiceForPurchase;
  }

  private getCaseProduct(): CaseProduct {
    let caseProduct;
    if (this.ApplicationProducts[0]) {
      caseProduct = this.ApplicationProducts[0].CaseProduct;
    }

    return caseProduct;
  }

  public getLoanType(): string {
    const caseProduct = this.getCaseProduct();
    if (caseProduct && caseProduct.Product) {
      return caseProduct.Product.LoanTypeCode;
    }
  }

  public isFactFindFirstStartEnabled(firstStart: string): boolean {
    return this.isPurchase && this.IsFactFind && firstStart === ReferenceDataOptionLists.AnswerTypeYes;
  }

  public initializeDependants(): void {
    if (this.Applicants[0].NumberOfDependants === 0 || !this.Applicants[0].ApplicantDependants) {
      this.PropertyOccupants = [];
    }
    for (let i = this.Applicants[0].ApplicantDependants.length; i < this.Applicants[0].NumberOfDependants; i++) {
      this.Applicants[0].ApplicantDependants.push(new ApplicantDependant());
    }
    if (this.Applicants[0].NumberOfDependants < this.Applicants[0].ApplicantDependants.length) {
      this.Applicants[0].ApplicantDependants = this.Applicants[0].ApplicantDependants.slice(
        0,
        this.Applicants[0].NumberOfDependants
      );
    }
  }

  public isFactFind2Visible(): boolean {
    return this.IsFactFind && this.FactFind2 !== undefined;
  }

  private setApplicationCaseDependentProperties(): void {
    this.isNorthernIrelandProperty =
      this.ApplicationCase.PropertyLocationCode === ReferenceDataOptionLists.PropertyLocationNorthernIreland;
    this.isScottishPropertyAndFullApplication =
      this.isScottishProperty && (this.IsFactFind || this.IsFullApp) && !this.isRemortgage;
    this.isInterestAnyOtherPropertyCodeVisible =
      this.isPurchase && this.ApplicationCase.LoanGroupTypeCode === ReferenceDataOptionLists.LoanGroupTypeResidential;
  }
}
